(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pack-builder"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  const $packOptions = $('.pack-option');
  const $addToPackButtons = $('.add-to-pack-btn');
  const $selectedItemsContainer = $('#selected-items-container');
  const $selectedItemsContainerCart = $('#selected-items-containerf');
  const $selectedCountElement = $('#selected-count');
  const $selectedCountElementCart = $('#selected-count-cart');
  const $packSizeElement = $('#pack-size');
  const $packSizeElementCart = $('#pack-size-cart');
  const $addPackToCartButton = $('#add-pack-to-cart');
  const $addPackToCartButtonCart = $('#add-pack-to-cart-2');

  let currentPackSize = 3;
  let packGroups = []; 
  let currentPackGroup = {
    timestamp: Date.now(),
    size: currentPackSize,
    products: []
  };

  function initializeNewPackGroup() {
    currentPackGroup = {
      timestamp: Date.now(),
      size: currentPackSize,
      products: []
    };
  }

  $packOptions.first().addClass('active');
  currentPackSize = parseInt($packOptions.first().data('pack-size'));
  updatePackSizeDisplays();
  initializeEmptyPlaceholders();

  function updatePackSizeDisplays() {
    $packSizeElement.text(currentPackSize);
    $packSizeElementCart.text(currentPackSize);
    initializeEmptyPlaceholders();
    updateAddToCartButtonState();
  }

  $packOptions.on('click', function() {
    $packOptions.removeClass('active');
    $(this).addClass('active');
    currentPackSize = parseInt($(this).data('pack-size'));
    updatePackSizeDisplays();
    updateBothDisplays();
  });

  $addToPackButtons.on('click', function() {
    const $productItem = $(this).closest('.product-item');
    const productId = $(this).data('product-id');
    const productTitle = $productItem.data('product-title');
    const productPrice = $productItem.data('product-price');
    const productImage = $productItem.find('img').attr('src');
    const productHandle = $productItem.data('product-handle');
    const productDescription = $productItem.find('.des').html();
    
    const $availableVariants = $productItem.find('.popup-size-swatches-source .size-swatch');
    const baseUrl = window.location.protocol + "//" + window.location.host;

    if ($availableVariants.length === 0) {
      alert('No sizes available for this product.');
      return;
    }
    
    let sizeSwatch = '';
    $availableVariants.each(function() {
      const variantId = $(this).data('variant-id');
      const variantTitle = $(this).data('variant-title');
      sizeSwatch += `
        <div class="popup-size-swatch" 
             data-variant-id="${variantId}" 
             data-variant-title="${variantTitle}">
          ${variantTitle}
        </div>
      `;
    });
    
    let quantityOptions = '';
    for (let i = 1; i <= 10; i++) {
      quantityOptions += `<option value="${i}">${i}</option>`;
    }
    
    const popupHTML = `
      <div class="product-popup-overlay">
        <div class="product-popup">
          <div class="product-popup-close">&times;</div>
          <div class="product-popup-content">
            <img src="${productImage}" alt="${productTitle}" class="popup-product-image">
            <div class="popup-product-details">
              <h2>${productTitle}</h2>
              <p class="popup-price">$${productPrice}</p>

              <div class="popup-description">
                <p>${productDescription}</p>
              </div>

              <button class="toggle-description">Show More</button>
            
              <div class="popup-variant">
                <label>Select Size:</label>
                <div class="popup-size-swatches">
                  ${sizeSwatch}
                </div>
              </div>
              <div class="popup-custom">
              <div class="popup-quantity">
                <label for="quantity-select"></label>
                <select id="quantity-select">
                  ${quantityOptions}
                </select>
              </div>
              
              <button class="add-to-pack-confirm" disabled>
                Add to Pack
              </button>
              </div>
              <a href="${baseUrl}/products/${productHandle}" class="add-to-pack-confirm custom-view-details" target="_blank">
                 View Full Details
              </a>
            </div>
          </div>
        </div>
      </div>
    `;
    
    $('body').append(popupHTML);
    
    $('.popup-size-swatch').on('click', function() {
      $('.popup-size-swatch').removeClass('selected');
      $(this).addClass('selected');
      
      $('.add-to-pack-confirm')
        .prop('disabled', false)
        .data('variant-id', $(this).data('variant-id'))
        .data('variant-title', $(this).data('variant-title'));
    });
    
    $('.product-popup-close').on('click', function() {
      $('.product-popup-overlay').remove();
    });
    
    $('.product-popup-overlay').on('click', function(e) {
      if ($(e.target).hasClass('product-popup-overlay')) {
        $('.product-popup-overlay').remove();
      }
    });
    
    $('.add-to-pack-confirm').on('click', function() {
      if (!$(this).data('variant-id')) {
        alert('Please select a size');
        return;
      }
      
      const selectedQuantity = parseInt($('#quantity-select').val());
      const selectedVariantId = $(this).data('variant-id');
      const selectedVariantTitle = $(this).data('variant-title');

      // Create a single product entry with quantity
      currentPackGroup.products.push({
        id: productId,
        title: productTitle,
        price: productPrice,
        image: productImage,
        size: selectedVariantTitle,
        variantId: selectedVariantId,
        quantity: selectedQuantity
      });

      updateBothDisplays();
      $('.product-popup-overlay').remove();
    });
  });

  function updateBothDisplays() {
    updateMainDisplay();
    updateCartDisplay();
  }

  function updateMainDisplay() {
    updateDisplayContainer($selectedItemsContainer, $selectedCountElement, currentPackGroup.products);
  }

  function updateCartDisplay() {
    updateDisplayContainer($selectedItemsContainerCart, $selectedCountElementCart, currentPackGroup.products);
  }

  function updateDisplayContainer($container, $countElement, products) {
    $container.empty();
    
    if (products.length === 0) {
      initializeEmptyPlaceholders();
    } else {
      // Track product quantities
      const productQuantities = {};
      
      // First, count quantities of each unique product
      products.forEach(product => {
        const key = `${product.id}-${product.size}`;
        productQuantities[key] = (productQuantities[key] || 0) + product.quantity;
      });

      // Get all empty placeholders initially
      const emptyPlaceholders = Array.from({ length: currentPackSize }, (_, i) => i + 1);
      
      // Track used products to avoid duplicates
      const usedProducts = new Set();

      products.forEach((product, index) => {
        const placeholderIndex = emptyPlaceholders.shift();
        
        const productKey = `${product.id}-${product.size}`;
        
        if (!usedProducts.has(productKey)) {
          const quantity = productQuantities[productKey];
          
          const itemElement = $('<div>', { 
            class: 'selected-item',
            'data-product-id': product.id,
            'data-size': product.size,
            'data-qty': quantity,
            'data-placeholder-index': placeholderIndex
          });
          
          const imageWrapper = $('<div>', { class: 'image-wrapper' });
          const productImage = $('<img>', {
            src: product.image,
            alt: product.title,
            class: 'selected-item-image'
          });
          
          const quantityBadge = quantity > 1 ? $('<div>', {
            class: 'quantity-badge',
            text: quantity
          }) : null;
          
          imageWrapper.append(productImage);
          if (quantityBadge) {
            imageWrapper.append(quantityBadge);
          }
          
          itemElement.append(imageWrapper);
          
          itemElement.append(`<span>${product.title} - ${product.size}</span>`);
          
          itemElement.append(`
            <button class="remove-item" 
                    data-product-id="${product.id}" 
                    data-size="${product.size}">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="10" fill="#000000"></circle>
                <path d="M6 6L14 14M14 6L6 14" stroke="white" stroke-width="2" stroke-linecap="round"></path>
              </svg>
            </button>
          `);
          
          $container.append(itemElement);
          
          usedProducts.add(productKey);
        }
      });

      // Add remaining empty placeholders if any spots are left
      const remainingSlots = currentPackSize - products.length;
      if (remainingSlots > 0) {
        emptyPlaceholders.forEach(index => {
          const emptyPlaceholder = `<div class="selected-item_pt empty"><span>${index}</span></div>`;
          $container.append(emptyPlaceholder);
        });
      }
    }

    $countElement.text(products.length);
    updateAddToCartButtonState();
  }

  $(document).on('click', '.remove-item', function(e) {
    e.stopPropagation(); 
    
    const $selectedItem = $(this).closest('.selected-item');
    const productId = $selectedItem.data('product-id');
    const size = $selectedItem.data('size');
    
    currentPackGroup.products = currentPackGroup.products.filter(product => 
      !(product.id === productId && product.size === size)
    );
    
    updateBothDisplays();
    updateAddToCartButtonState();
  });
  
  function updateCartDrawer(cart) {
    const $cartItemsContainer = $('.cart-drawer__items');
    
    if (!cart.items.length) {
      $cartItemsContainer.html('<p class="cart-empty-message">Your cart is empty</p>');
      return;
    }

    // Group items by timestamp and pack size, tracking full details
    const groupedItems = {};
    cart.items.forEach(item => {
      const timestamp = item.properties.Timestamp;
      const packSize = item.properties["Pack Size"];
      const key = `${timestamp}-${packSize}`;
      
      if (!groupedItems[key]) {
        groupedItems[key] = {
          timestamp: timestamp,
          packSize: packSize,
          items: [],
          total: 0
        };
      }
      
      groupedItems[key].items.push({
        id: item.id,
        title: item.title,
        image: item.image,
        quantity: item.quantity,
        size: item.properties.Size,
        linePrice: item.final_line_price
      });
      groupedItems[key].total += item.final_line_price;
    });

    $cartItemsContainer.empty();

    // Render each pack group
    Object.values(groupedItems).forEach(group => {
      const packHeader = $('<div>', { 
        class: 'cart-timestamp-group',
        html: `
          <div class="cart-timestamp-header">
            <div class="timestamp-header-content">
              <span>${group.packSize}-Pack (${new Date(group.timestamp).toLocaleString()})</span>
              <button class="remove-pack-btn" data-timestamp="${group.timestamp}">Remove Pack</button>
            </div>
          </div>
        `
      });

      const itemsContainer = $('<div>', { class: 'pack-items' });
      
      // Group items by unique product and size
      const consolidatedItems = {};
      group.items.forEach(item => {
        const key = `${item.title}-${item.size}`;
        if (!consolidatedItems[key]) {
          consolidatedItems[key] = { ...item };
        } else {
          consolidatedItems[key].quantity += item.quantity;
          consolidatedItems[key].linePrice += item.linePrice;
        }
      });

      // Render consolidated items
      Object.values(consolidatedItems).forEach(item => {
        itemsContainer.append(`
          <div class="line-item">
            <div class="line-item__media">
              <img src="${item.image}" alt="${item.title}">
              ${item.quantity > 1 ? `<div class="quantity-badge">${item.quantity}</div>` : ''}
            </div>
            <div class="line-item-info">
              <h6>${item.title}</h6>
              <p>Size: ${item.size}</p>
              <p>${formatMoney(item.linePrice)}</p>
            </div>
          </div>
        `);
      });

      packHeader.append(itemsContainer);
      packHeader.append(`
        <div class="pack-total">
          Pack Total: ${formatMoney(group.total)}
        </div>
      `);

      $cartItemsContainer.append(packHeader);
    });

    // Update cart total
    const cartTotal = Object.values(groupedItems).reduce((total, group) => total + group.total, 0);
    $('.cart-drawer__footer [bss-b2b-cart-total-price]').text(formatMoney(cartTotal));

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }

  // function addItemsToCart(items) {
  //   const packItems = [];

  //   items.forEach(item => {
  //     // Duplicate items based on their quantity
  //     for (let i = 0; i < item.quantity; i++) {
  //       const packItemCopy = {
  //         ...item,
  //         quantity: 1,
  //         properties: {
  //           ...item.properties,
  //           "Individual Quantity": item.quantity
  //         }
  //       };
  //       packItems.push(packItemCopy);
  //     }
  //   });

  //   // Function to add items in batches to handle potential limitations
  //   function addItemsInBatches(itemsToAdd, isPackItems = false) {
  //     if (itemsToAdd.length === 0) return;

  //     // Split items into smaller batches
  //     const batchSize = 5; // Adjust based on your cart's constraints
  //     for (let i = 0; i < itemsToAdd.length; i += batchSize) {
  //       const batch = itemsToAdd.slice(i, i + batchSize);
        
  //       $.ajax({
  //         type: 'POST',
  //         url: '/cart/add.js',
  //         data: { items: batch },
  //         dataType: 'json',
  //         success: function(response) {
  //           console.log(response);
  //           console.log(isPackItems ? 'Pack items added successfully' : 'Individual products added successfully');
  //           fetch('/cart.js')
  //           .then(response => response.json())
  //           .then(cart => {
  //             if (cart.items.length > 0) {
  //               const cartDrawer = document.getElementById('cart-drawer');
  //               if (cartDrawer) {
  //                 cartDrawer.style.display = 'block';
  //                 cartDrawer.setAttribute('open', '');
  //               }
  //               updateCartDrawer(cart);
  //             }
  //           })
  //           .catch(error => console.error('Error fetching cart:', error));
  //         },
  //         error: function(xhr) {
  //           console.error(isPackItems ? 'Error adding packs:' : 'Error adding individual products:', xhr.responseText);
  //         }
  //       });
  //     }
  //   }

  //   // Add pack items in batches
  //   if (packItems.length > 0) {
  //     addItemsInBatches(packItems, true);
  //   }
  // }

  function addItemsToCart(items) {
  const packItems = [];

  // Ensure ALL selected items are added, even if quantity was previously set
  items.forEach(item => {
    // Always add the full quantity of each unique product
    const packItemCopy = {
      id: item.id,
      quantity: item.quantity, // Use the original quantity
      properties: {
       // "Pack Size": currentPackSize,
       // "Product Name": item.properties["Product Name"],
      //  "Size": item.properties.Size,
        "Timestamp": new Date(currentPackGroup.timestamp).toISOString(),
       // "Individual Quantity": item.quantity
      }
    };
    packItems.push(packItemCopy);
  });

  // Function to add items in batches
  function addItemsInBatches(itemsToAdd, isPackItems = false) {
    if (itemsToAdd.length === 0) return;

    const batchSize = 5;
    for (let i = 0; i < itemsToAdd.length; i += batchSize) {
      const batch = itemsToAdd.slice(i, i + batchSize);
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items: batch },
        dataType: 'json',
        success: function(response) {
          console.log(isPackItems ? 'All pack items added successfully' : 'Individual products added successfully');
          
          // Fetch and update cart to confirm all items were added
          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            console.log('Total items in cart:', cart.items.length);
            if (cart.items.length > 0) {
              const cartDrawer = document.getElementById('cart-drawer');
              if (cartDrawer) {
                cartDrawer.style.display = 'block';
                cartDrawer.setAttribute('open', '');
              }
              updateCartDrawer(cart);
            }
          })
          .catch(error => console.error('Error fetching cart:', error));
        },
        error: function(xhr) {
          console.error(isPackItems ? 'Error adding packs:' : 'Error adding individual products:', xhr.responseText);
        }
      });
    }
  }

  // Add all pack items in batches
  if (packItems.length > 0) {
    addItemsInBatches(packItems, true);
  }
}

  
  // $addPackToCartButton.add($addPackToCartButtonCart).on('click', function() {
  //   const items = currentPackGroup.products.map(product => ({
  //     id: product.variantId,
  //     quantity: product.quantity,
  //     properties: {
  //       "Pack Size": currentPackSize,
  //       "Product Name": product.title,
  //       "Size": product.size,
  //       "Timestamp": new Date(currentPackGroup.timestamp).toISOString()
  //     }
  //   }));

  //   addItemsToCart(items);
  //   packGroups.push({...currentPackGroup}); 
  //   initializeNewPackGroup(); 
  //   updateBothDisplays();
  // });
  $addPackToCartButton.add($addPackToCartButtonCart).on('click', function() {
  console.log('Current Pack Group:', currentPackGroup);
  
  const items = currentPackGroup.products.map(product => ({
    id: product.variantId,
    quantity: product.quantity,
    properties: {
      "Pack Size": currentPackSize,
      "Product Name": product.title,
      "Size": product.size,
      "Timestamp": new Date(currentPackGroup.timestamp).toISOString()
    }
  }));

  console.log('Items to be added:', items);

  addItemsToCart(items);
  packGroups.push({...currentPackGroup}); 
  initializeNewPackGroup(); 
  updateBothDisplays();
});

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  function updateAddToCartButtonState() {
    const isComplete = currentPackGroup.products.length === currentPackSize;
    $addPackToCartButton.toggleClass('pack-complete', isComplete);
    $addPackToCartButtonCart.toggleClass('pack-complete', isComplete);
  }

  function initializeEmptyPlaceholders() {
    if (currentPackGroup.products.length === 0) {
      const emptyPlaceholders = Array(currentPackSize).fill(0).map((_, i) => 
        `<div class="selected-item_pt empty"><span>${i + 1}</span></div>`
      ).join('');
      
      $selectedItemsContainer.html(emptyPlaceholders);
      $selectedItemsContainerCart.html(emptyPlaceholders);
    }
  }

  // Price calculation and display
  document.addEventListener('DOMContentLoaded', function() {
    function calculatePackPrices(basePrice, packSize, discountPercentage) {
      const originalPrice = basePrice * packSize;
      const discountedPrice = originalPrice * (1 - discountPercentage / 100);
      return {
        original: originalPrice.toFixed(2),
        discounted: discountedPrice.toFixed(2)
      };
    }

    // Initialize pack prices
    function initializePackPrices() {
      const packOptions = document.querySelectorAll('.pack-option');
      
      packOptions.forEach((pack) => {
        const packSize = parseInt(pack.dataset.packSize);
        const discount = parseFloat(pack.dataset.discount);
        const basePrice = parseFloat(pack.dataset.basePrice);
        
        const prices = calculatePackPrices(basePrice, packSize, discount);
        
        // Update price displays
        pack.querySelector('.pack-price').textContent = `$${prices.discounted}`;
        pack.querySelector('.original-price').textContent = `$${prices.original}`;
      });
    }

    // Initialize when page loads
    initializePackPrices();
  });
});

  } catch(e) { console.error(e); }
})();
})();
